import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

export type AlertProps = {
  alertType: string;
  setAlertType: React.Dispatch<React.SetStateAction<string>>;
};
export const AlertContext = createContext<AlertProps | null>(null);

export function useAlert() {
  const ctx = useContext(AlertContext);
  return ctx;
}
export const alertBannerType = {
  USER_LOGIN_ERROR: 'user.login.error',
  A2_PROFILE_ERROR: 'a2.profile.error',
  USER_FAVORITE_ERROR: 'user.fav.error',
  USER_EXTENDED_DETAILS_ERROR: 'user.extended.details.error',
  USER_LOGIN_TIMEOUT_ERROR: 'user.login.timeout.error',
};
export default function AlertProvider({ children }: { children: ReactNode }): JSX.Element {
  const [alertType, setAlertType] = useState('');

  return (
    <AlertContext.Provider
      value={{
        setAlertType,
        alertType,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
}
